import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class OperatorRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param organizationId
   */
  getOperatorList(token: string, organizationId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, organizationId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   */
  assignableList(token: string, orgId: number, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_ASSIGNABLE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, orgId.toString());
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  assignedList(token: string, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_ASSIGNED;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param organizationId
   */
  getOperatorLevel(token: string, organizationId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_LEVEL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, organizationId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param operatorId
   */
  getOperatorCounter(token: string, operatorId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.GET_OPERATOR_COUNTER;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.OPERATOR_ID, operatorId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param operatorId
   */
  getDetail(token: string, operatorId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_DETAIL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.OPERATOR_ID, operatorId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param organizationId
   * @param data
   */
  create(token: string, organizationId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_CREATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, organizationId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().post(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param organizationId
   * @param operatorId
   * @param data
   */
  update(
    token: string,
    organizationId: number,
    operatorId: number,
    data: string,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, organizationId.toString());
    form.set(RequestField.OPERATOR_ID, operatorId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().post(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   * @param operatorId
   */
  assign(token: string, deviceId: number, operatorId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_ASSIGN;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());
    form.set(RequestField.OPERATOR_ID, operatorId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   * @param operatorId
   */
  unassign(token: string, deviceId: number, operatorId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_UNASSIGN;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());
    form.set(RequestField.OPERATOR_ID, operatorId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   * @param operatorId
   */
  resetPassword(token: string, organizationId: number, operatorId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.OPERATOR_RESET_PASSWORD;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, organizationId.toString());
    form.set(RequestField.OPERATOR_ID, operatorId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
